export default (type, payload, name) => ({
  type,
  payload,
  name,
})



// WEBPACK FOOTER //
// ./src/helpers/buildActionWithName.js